import { Link } from 'react-router-dom'

// "Related" link cards for the bottom of content pages.
// links: [{ to, label, desc }]
export default function Related({ title = 'Related', links }) {
  if (!links?.length) return null
  return (
    <section className="related">
      <h2 className="related-title">{title}</h2>
      <div className="related-grid">
        {links.map((l) => (
          <Link key={l.to} to={l.to} className="card related-card">
            <strong>{l.label}</strong>
            {l.desc && <span>{l.desc}</span>}
          </Link>
        ))}
      </div>
    </section>
  )
}
